/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

// Redux Store
import { ControlTable } from "../Table";
import { getParams } from "../../utils/params";
import { get } from "lodash";
import useForm from "../../hooks/useForm";
import Inquiry from "./Inquiry";
//import { ANSWERED_STATUS } from "../../constants/CONSULTING";
import Filters from "../Filters";
import { getInquiryList } from "../../apis/admin/inquiry";


const Inquirys = () => {
  const [fields] = useState([
    { title: "문의자", key: 'user.name' },
    { title: "제목", key: 'title' },
    // { title: "내용", key: 'content' },
    {
      title: "답변여부", key: 'answer', onValue: (data) => {
        return !!data ? 'Y' : 'N'
      }
    },
    // { title: "상태", key: 'state' },
    { title: "요청 날짜", label: '-', key: "createdTime", type: 'datetime' },
    {
      type: 'button',
      size: 'x-sm',
      color: 'gray-line',
      label: '상담 내역',
      onClick: ({ data }) => {
        setDetailOpen(true)
        setSelectedItem(data)
      }
    }
  ]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      order: [
        {
          idx: "desc"
        },
      ],
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);

  const submit = (param) => {
    getInquiryList({
      ...getParams({
        ...param,
        search: {
          ...param.search ? param.search : {}
        }
      }),

    })
      .then((res) => {
        setIsLoading(false)
        setTotal(get(res, "data.total"));
        setList(get(res, "data.inquirys"));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false)
      })
  };


  const [filters] = useState([
    // {
    //   title: "기간",
    //   type: "CustomDatePicker",
    //   key: "range.createdTime",
    // },
    // {
    //   title: "답변",
    //   type: "select",
    //   key: "search.isAnswered",
    //   defaultValue: '',
    //   options: {
    //     list: [
    //       { label: "전체", value: '' },
    //       ...ANSWERED_STATUS
    //     ]
    //   },
    // },
    // {
    //   title: "상호",
    //   key: "search.companyName",
    //   options: {
    //     placeholder: "검색어 입력",
    //   },
    // },
    // {
    //   title: "신청자이름",
    //   key: "search.name",
    //   options: {
    //     placeholder: "검색어 입력",
    //   },
    // },
  ])


  return (
    <>

      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
      // isControl={false}
      />
      <Inquiry
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={filterSubmit}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
    </>
  );
};

export default Inquirys